angular.module("ainapp")
    .controller("batchLedgerController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Batch Ledger";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Brands = [];
            MainService.BrandsInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Brands = response.data;
                $scope.Brands.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.Categories = [];
            MainService.ProductsParentList("Product").then(function (response) {
                $scope.Categories = response.data;
            });

            $scope.GetSub = function () {
                $scope.Parents = [];
                MainService.ProductSubList($scope.filter.ProductGroupId, "Product").then(function (response) {
                    $scope.Parents = response.data;
                });
            }

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })

            $scope.productSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {

                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                };
                                o.data.filter.filters.push(temp);
                            }
                        }

                        MainService.productForMultiSelect(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            //toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 50
            };

            $scope.selectProductsOptions = {
                placeholder: "Select Products...",
                dataTextField: "Name",
                filter: "contains",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };

            $scope.selectProductCodeOptions = {
                placeholder: "Select Product Codes...",
                dataTextField: "ProductCode",
                dataValueField: "Id",
                filter: "contains",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.productSelectDataSource
            };


            $scope.$on('$includeContentLoaded', function (event, templateName) {
                if (templateName === 'templates/common/stockFilterModal.html') {
                    $('#filterModal').modal('show');
                }
            });

            $scope.Init = function () {

                $scope.date1 = new Date();
                var n = $scope.date1.getFullYear();
                $scope.d2 = new Date("01/01/" + n);

                $scope.filter = {
                    FromDate: $scope.d2,
                    ToDate: new Date(),
                    ProductIds: [],
                    WarehouseIds: [],
                    isLoad: false,
                    Keyword: "",
                    BranchId: "",
                }

            }
            $scope.Init();


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        if ($scope.filter.isLoad) {
                            o.data.FromDate = $scope.filter.FromDate;
                            o.data.ToDate = $scope.filter.ToDate;
                            o.data.ProductIds = $scope.filter.ProductIds;
                            o.data.WarehouseIds = $scope.filter.WarehouseIds;
                            o.data.Keyword = $scope.filter.Keyword;
                            o.data.BranchId = $scope.filter.BranchId;
                            o.data.ProductGroupId = $scope.filter.ProductGroupId;
                            o.data.ProductParentId = $scope.filter.ProductParentId;

                            o.data.FromDateString = $scope.extractDate($scope.filter.FromDate);
                            o.data.ToDateString = $scope.extractDate($scope.filter.ToDate);

                            MainService.BatchLedger(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            })

                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    },

                },
                change: function (data) {
                    if (data.items.length > 0) {
                        data.sender._aggregateResult.Balance.count = 0;
                        angular.forEach(data.items, function (a) {
                            a.aggregates.Balance.count = Math.abs(a.aggregates.Received.sum - a.aggregates.Issued.sum);
                            a.aggregates.Balance.count = Math.round(a.aggregates.Balance.count * 100) / 100;
                        })
                        data.sender._aggregateResult.Balance.count = Math.abs(data.sender._aggregateResult.Received.sum - data.sender._aggregateResult.Issued.sum);
                        data.sender._aggregateResult.Balance.count = Math.round(data.sender._aggregateResult.Balance.count * 100) / 100;
                    }
                },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            InvNo: {
                                type: "text",
                                editable: false,
                            },
                            InvType: {
                                type: "text",
                                editable: false,
                            },
                            Received: {
                                type: "number",
                                editable: false,
                            },
                            Issued: {
                                type: "number",
                                editable: false,
                            },
                            "BatchLedger.BatchNo": {
                                type: "text",
                                editable: false,
                            },
                            "BatchLedger.ManufDate": {
                                type: "date",
                                editable: false,
                            },
                            "BatchLedger.ExpiryDate": {
                                type: "date",
                                editable: false,
                            },
                            "BatchLedger.Quantity": {
                                type: "number",
                                editable: false,
                            },
                            "BatchLedger.Balance": {
                                type: "number",
                                editable: false,
                            },
                            "BatchLedger.ProductName": {
                                type: "string",
                                editable: false,
                            },
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                //pageSize: 20,
                group: [{
                    field: "BatchLedger.BatchNo",
                    aggregates: [
                        {
                            field: "Received",
                            aggregate: "sum"
                        },
                        {
                            field: "Issued",
                            aggregate: "sum"
                        },
                        {
                            field: "Balance",
                            aggregate: "count"
                        },
                    ]
                }],
                aggregate: [
                    {
                        field: "Received",
                        aggregate: "sum"
                    },
                    {
                        field: "Issued",
                        aggregate: "sum"
                    },
                    {
                        field: "Balance",
                        aggregate: "count"
                    },
                ],
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                selectable: true,
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },
                dataBound: onDataBound,

                columns: [

                    {
                        field: "BatchLedger.BatchNo",
                        title: "Batch No",
                        hidden: true,
                    },
                    {
                        field: "BatchLedger.ProductName",
                        title: "Product",
                    },
                    {
                        field: "BatchLedger.ManufDate",
                        title: "Manuf Date",
                        template: "#= kendo.toString(kendo.parseDate(BatchLedger.ManufDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                    },
                    {
                        field: "BatchLedger.ExpiryDate",
                        title: "Expiry Date",
                        template: "#= kendo.toString(kendo.parseDate(BatchLedger.ExpiryDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                    },
                    //                    {
                    //                        field: "BatchLedger.Quantity",
                    //                        title: "Quantity",
                    //                        },
                    //                    {
                    //                        field: "BatchLedger.Balance",
                    //                        title: "Balance",
                    //                        },
                    {
                        field: "InvNo",
                        title: "Inv No",
                    },
                    {
                        field: "InvType",
                        title: "Inv Type",
                    },
                    {
                        field: "Received",
                        title: "Received",
                        template: "<div style='text-align: right'>#=kendo.toString(Received, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Received</div>"),
                    },
                    {
                        field: "Issued",
                        title: "Issued",
                        template: "<div style='text-align: right'>#=kendo.toString(Issued, 'n')#</div>",
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                        headerTemplate: kendo.template("<div class='headerright'>Issued</div>"),
                    },
                    {
                        field: "Balance",
                        title: "Balance",
                        //template: "<p>{{dataItem.Date | date: 'dd/MM/yyyy'}}</p>",
                        groupFooterTemplate: "Balance: #=kendo.toString(count, 'n')#",
                        footerTemplate: "<div style='text-align: right'>Balance: #=kendo.toString(count, 'n')#</div>",
                    },
                ],
            };

            function onDataBound() {
                var grid = this;
                grid.element.on('dblclick', 'tbody tr[data-uid]', function (e) {
                    grid = $("#Kendo-Grid").data("kendoGrid");
                    var selectedData = grid.dataItem(grid.select());
                    $scope.goLegerVoucher(selectedData);
                })
            }



            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.filterData = function () {
                $scope.filter.isLoad = true;
                $('#filterModal').modal('hide');
                console.log($scope.filter)
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refreshData = function () {
                $scope.Init();
                $('#filterModal').modal('show');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.goLegerVoucher = function (selectedData) {

                console.log(selectedData)

                if (selectedData.InvType == "Sales Invoice") {

                    var url = $state.href('editSalesInvoice', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Sales Invoice 2") {

                    var url = $state.href('editSalesInvoice2', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Sales Invoice 3") {

                    var url = $state.href('editSalesInvoice3', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Sales Invoice 4") {

                    var url = $state.href('editSalesInvoice4', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Sales Return") {

                    var url = $state.href('editSalesReturn', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Credit Note SR") {

                    var url = $state.href('editCreditNoteSR', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Purchase Invoice") {

                    var url = $state.href('editPurchaseInvoice', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Purchase Return") {
                    var url = $state.href('editPurchaseReturn', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Opening Balance") {

                    var url = $state.href('editOpeningBalance', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Fund Payment Voucher") {

                    var url = $state.href('editFPVMaster', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');



                } else if (selectedData.InvType == "Fund Receipt Voucher") {

                    var url = $state.href('editFRVMaster', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');



                } else if (selectedData.InvType == "Cash Payment Voucher") {

                    var url = $state.href('editCPVMaster', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Cash Receipt Voucher") {

                    var url = $state.href('editCRVMaster', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Cheque Payment Voucher") {

                    var url = $state.href('editChequePVMaster', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Cheque Receipt Voucher") {

                    var url = $state.href('editChequeRVMaster', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Journal Voucher") {

                    var url = $state.href('editJVMaster', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Company Expense") {

                    var url = $state.href('editcompanyExpense', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Counter Sales") {

                    var url = $state.href('counterSalesEdit', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Counter Sales") {
                    //                $state.go("editPurchaseInvoice", {
                    //                    VoucherId: selectedData.
                    //                })
                }
                //            if (selectedData.Type == "Contract Invoice") {
                //                $state.go("editPurchaseInvoice", {
                //                    VoucherId: selectedData.
                //                })
                //            }
                else if (selectedData.InvType == "Direct Sales Invoice") {
                    var url = $state.href('editDirSalesInvoice', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Direct Purchase Invoice") {
                    var url = $state.href('editDirPurchaseInvoice', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Export Sales Invoice") {

                    var url = $state.href('editExpSalesInvoice', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Export Purchase Invoice") {

                    var url = $state.href('editExpPurchaseInvoice', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Import Purchase Invoice") {

                    var url = $state.href('editImpPurchaseInvoice', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Opening Stock") {

                    var url = $state.href('editOpeningStock', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Stock Issue") {

                    var url = $state.href('editStockIssue', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Stock FOC") {

                    var url = $state.href('editStockFOC', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Stock Receive") {

                    var url = $state.href('editStockRecieve', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');



                } else if (selectedData.InvType == "Delivery Note") {

                    var url = $state.href('editDeliveryNote', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Stock JV") {

                    var url = $state.href('editStockJV', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Credit Note") {

                    var url = $state.href('editCreditNote', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Debit Note") {

                    var url = $state.href('editDebitNote', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                } else if (selectedData.InvType == "Goods Received") {

                    var url = $state.href('editGoodsReceived', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');


                }
                //                else if (selectedData.Type == "Porfoma Invoice") {
                //
                //                    var url = $state.href('editStockJV', {
                //                        VoucherId: selectedData.ProSalesInvoiceId
                //                    });
                //                    $window.open(url, '_blank');
                //
                //
                //                } 
                else if (selectedData.InvType == "Individual Sales Invoice") {

                    var url = $state.href('editIndSalesInvoice', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                } else if (selectedData.InvType == "Individual Purchase Invoice") {

                    var url = $state.href('editIndPurchaseInvoice', {
                        VoucherId: selectedData.InvId
                    });
                    $window.open(url, '_blank');

                }
            }



        }])
